import { Box, Dialog, DialogContent, DialogTitle, FormControlLabel, IconButton, InputLabel, styled, TextField, Typography, useTheme } from "@mui/material";
import { SxProps } from "@mui/system";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../configuration/themeSettings";


export const Root = styled("div", { label: "homePage" })
    (() => ({
        display: "flex",
        flex: 1,
        flexDirection: "column",

        "@media print": {
            height: 'auto',
            position: 'relative',
            //  border: '1px solid blue',
        }
    }));

export const BasketHeaderTypography = styled(Typography, { label: "BasketHeader_Typography" })(({ theme }) => ({
    textAlign: "left",
    color: StyleguideSavioColors.mainBlue,
    fontWeight: StyleguideSavioFonts.bold,
}));

export const StylePathBox = styled(Box, {
    label: "basketHeader_Typography",
})(({ theme }) => ({
    width: "100%",
    display: "inline",

}));

export const Container = styled("div", { label: "BasketPage-Container" })
    ((theme) => ({
        width: '100%',
        maxWidth: "calc(" + MiscSavio.maxWidth1500 + "px + 20px)",
        paddingLeft: 10,
        paddingRight: 10,
        margin: "0 auto",
        paddingBottom: 5,
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100vh - 133px)',
        "@media print": {
            height: '100%',
            position: 'relative',
            // border: '1px solid blue',
        }
    }));

export const ContainerHeadBasket = styled(Box, { label: "BasketPage-ContainerHeadBasket" })
    ((theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 17,

        "@media print": {
            paddingRight: 0,



            '> div:last-child': {
                display: 'none',
            },




        },

        //tabella principale
        "+ div > div:first-of-type": {

            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            height: 'calc(100vh - 318px)',

            "@media print": {
                height: 'auto',
            },

            '> div': {
                paddingBottom: 0,
                "> div:nth-of-type(2)": {
                    flexGrow: 1,
                }
            },

            "table": {

                pageBreakInside: 'auto',


                'tr': { pageBreakInside: 'avoid', },


                'thead': {
                    'th': {
                        '&.qty': {

                            width: 49,

                            '> span': {
                                "@media print": {
                                    textAlign: 'right',
                                },
                            }
                        },
                        '&.deleteRow': {
                            width: 15,
                            minWidth: 15,
                        }
                    }
                },
                'tbody': {
                    'tr': {
                        'td': {
                            '&.deleteRow': {
                                width: 20,

                                'button': {
                                    color: StyleguideSavioColors.mainBlue,
                                    'svg': {
                                        fontSize: 14,
                                    }
                                }
                            },
                            '&.qty ': {




                                "@media print": {
                                    textAlign: 'right',
                                },








                                '> div': {

                                    justifyContent: 'flex-end',
                                    '> div': {
                                        width: 'auto',
                                        '> div:first-of-type': {
                                            marginRight: 10,
                                        }
                                    }
                                }

                            },
                            '&.discount ': {


                                'p': { fontSize: 14, lineHeight: '31px', }
                            },
                            '&.codeDescription': {

                                '> div': {
                                    '> div': {
                                        'p': {
                                            maxWidth: '100%',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        },
                                        'button': {
                                            padding: 3,
                                            marginRight: 5,
                                        }
                                    },

                                }
                            }
                        },

                        '&:hover': {

                            'td': {
                                textDecoration: 'none',

                                'p:not(.notMachine)': { textDecoration: 'underline', },

                                '&.qty': { textDecoration: 'underline' },
                                '&.fullPrice': { textDecoration: 'underline' },
                                '&.netPrice': { textDecoration: 'underline' },

                                '&.discount': {
                                    color: 'inherit',
                                    'p': { color: 'inherit', },
                                }



                            },

                            'td.codeDescription': {

                                'p.notMachine': {
                                    textDecoration: 'none',
                                    color: StyleguideSavioColors.grey,
                                }
                            }
                        }
                    }
                }

            }
        }

    })
    );

export const PageTitle = styled("div", { label: "BasketPage-pageTitle" })
    (({ theme }) => ({
        display: "flex",
        padding: "3px 0",
        color: StyleguideSavioColors.text.grayTitles,
        fontSize: 20,
        fontWeight: StyleguideSavioFonts.bold,
        alignItems: 'center',

        "@media print": {
            width: '100%',
            justifyContent: 'space-between',
            flexDirection: 'row-reverse',

            '> div:first-of-type': {
                textAlign: 'right',
                marginRight: 10,

                'p': {
                    color: StyleguideSavioColors.text.black,
                    lineHeight: '15px',
                }
            },
        },

        '> div:last-child': {
            alignItems: 'center',
            display: "flex",
        },
        "svg": {
            fontSize: 31,
            marginRight: 5,
            color: StyleguideSavioColors.grayBreadcrumb,
        }
    }));

export const TablePrice = styled("table", { label: "BasketPage-TablePrice" })(({ theme }) => ({
    textTransform: 'uppercase',
    marginRight: '4.5%',
    "@media print": {
        marginRight: 0,
    },
    "tr td:first-of-type": { paddingRight: 10, },
    'tr': {
        '&.totalGrossPrice': {
            color: StyleguideSavioColors.mainBlue,
            fontWeight: StyleguideSavioFonts.bold,
            fontSize: 16,
        },
        '&.totalNetPrice': {
            fontSize: 16,
        },
        '&.totalDiscount': {
            fontSize: 14,
            fontStyle: 'italic',

            'td:last-child': {
                fontStyle: 'normal'
            }
        }
    }
})
);

export const DialogContentResults = styled(Box, {
    label: "BasketAddPartByRef_DialogContent-results",
})(({ theme }) => ({
    maxHeight: '400px',
    minHeight: '400px',
}));

export const MessageBasketEmpty = styled(Typography, { label: "BasketNotItemPage-MessageBasketEmpty" })
    ((theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: StyleguideSavioColors.text.grayTitles,
        "svg": {
            color: StyleguideSavioColors.blue,
        }

    }));

export const BoxMessageBasketEmpty = styled(Box, { label: "BasketNotItemPage-BoxMessageBasketEmpty" })
    ((theme) => ({
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        'svg': {
            fontSize: 50,
        }

    }));

export const TableAndPrices = styled('div', { label: "BasketPage-TableAndPrices" })
    ((theme) => ({

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: 'calc(100vh - 190px)',

        "table tr": {
            'td': {
                '&.discount p': {
                    fontSize: '14px !important',
                   lineHeight: '31px',
                },
                '&.note':{
                    '.MuiIconButton-root':{
                        color: StyleguideSavioColors.mainBlue,
                    }
                }
            },

            '&:hover': {
                "td": {
                    "&.discount, &.qty, &.grossUnitPrice, &.netTotalPrice ": {
                        textDecoration: 'none !important',
                        "p, div": {
                            textDecoration: 'none !important',
                        }
                    },
                    '&.discount': {

                        'p': {
                            color: StyleguideSavioColors.text.black,
                        }
                    }
                }
            }
        },

        "@media print": {
            display: 'block',
            height: 'auto',
            position: 'relative',

            '> div:first-of-type': {
                height: 'auto !important',
                position: 'relative',

                '> div': {

                    height: '100% !important',

                }
            },

            '> div:last-child': {


                '> div': {

                    boxShadow: 'none',

                }
            },

            '.deleteRow': {

                display: 'none',
            },

            'table th:nth-last-of-type(2), table td:nth-last-of-type(2) ': {
                paddingRight: 20,
            },

            'thead': {
                //non fa duplicare il thead in caso di stampa di multipagina
                //pageBreakInside: 'auto',
            }

        }
    }));

export const AppModalDialog = styled(Dialog, {
    label: "app-modal-dialog",
})(({ theme }) => ({
    " .MuiPaper-root": {
        maxWidth: 778,

    }
}));

export const AppModalTitle = styled(DialogTitle, {
    label: "app-modal-dialog-title",
})(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    padding: "10px 20px",
    textTransform: 'uppercase',
}));

export const IconButtonClose = styled(IconButton, {
    label: "app-modal-dialog-iconButtonClose",
})(({ theme }) => ({

    "svg": { fontSize: 18.5, }
}));


export const TextFieldStyled = styled(TextField, {
    label: "app-modal-TextFieldStyled",
})(({ theme }) => ({

    '.MuiInputLabel-root:not(.Mui-focused):not(.MuiInputLabel-shrink)': {
        transform: 'translate(14px, 13px) scale(1)',
    }
}));

export const InputLabelStyled = styled(InputLabel, {
    label: "app-modal-InputLabelStyled",
})(({ theme }) => ({

    color: StyleguideSavioColors.text.black,
    fontWeight: StyleguideSavioFonts.normal,
    fontSize: 12,
    marginTop: 10,
    marginLeft: 20,
}));

export const DialogContentStyled = styled(DialogContent, {
    label: "app-modal-DialogContentStyled",
})(({ theme }) => ({
    fontSize: 14,
    padding: 0,
    maxHeight: 400,

    ">ul": {
        padding: 0,
    },

    "ul li": {
        fontSize: 14,
        paddingTop: 2,
        paddingBottom: 2,
        color: StyleguideSavioColors.text.black + " !important",
    },
    ".MuiMenuItem-root:hover": {
        backgroundColor: "#fff !important",
        textDecoration: 'underline',
        color: StyleguideSavioColors.blue + " !important",
        "&:before": {
            display: 'block',
            content: "''",
            width: 3,
            height: '100%',
            backgroundColor: StyleguideSavioColors.blue,
            left: 0,
            position: 'absolute',
            zIndex: 1,

        },
    }
}));

export const FormControlLabelStyled = styled(FormControlLabel, {
    label: "app-modal-FormControlLabelStyled",
})(({ theme }) => ({

    color: StyleguideSavioColors.text.black,
}));






export const useClasses = () => {
    const theme = useTheme();

    const classes = {
        tableAndPrices:{
            
            '> div:last-child':{
                boxShadow: 'none !important',
                
                '>div':{
                    boxShadow: 'none !important',
                }
            }
        }as SxProps,
        dotMenu: {
            float: "right",
            color: "inherit",
            '@media print': {
                display: 'none !important',
            }
        } as SxProps,
        noPrint: {
            "@media print": {
                display: "none !important",
            }
        } as SxProps,

        listItem: {
            display: 'flex',
            flexDirection: 'column',
            margin: 0,
            padding: 0,


            overflow: 'hidden',
            overflowY: 'auto',
            height: 305,
            minHeight: 'auto',
            maxHeight: 'none',

            "> li.Mui-selected, > li.Mui-selected:hover": {
                backgroundColor: MiscSavio.hoverBackgroundTable,
                color: '#fff',
            },

            'li': {
                width: '100%',
                textAlign: 'left',
                height: 49,
                minHeight: 49,
                borderBottom: '1px solid ' + StyleguideSavioColors.lightGrey,
                color: StyleguideSavioColors.text.black,
                backgroundColor: '#fff',

                "&:not(.Mui-selected):hover": {
                    backgroundColor: '#fff',
                    color: StyleguideSavioColors.blue,
                    textDecoration: 'underline',
                    "&:before": {
                        display: 'block',
                        content: "''",
                        width: 3,
                        height: '100%',
                        backgroundColor: StyleguideSavioColors.blue,
                        left: 0,
                        position: 'absolute',
                        zIndex: 1,

                    },
                    ' .MuiListItemButton-root': {
                        backgroundColor: '#fff',
                    },
                    cursor: 'pointer',
                },


                '&:last-child': {
                    borderBottom: 0,

                },
            }
        } as SxProps,

    };
    return classes;
};
